//Action creator with callback function
export function addWebDataCollectionV2(webDataCollection) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_WEB_DATA_COLLECTION_V2',
                payload: webDataCollection
            });
            resolve(true)
        });
    }
};

export const resetWebDataCollectionV2 = () => ({
    type: 'RESET_WEB_DATA_COLLECTION_V2'
});